import { FC } from 'react';

import errorIcon from '../assets/li_error.svg';
import infoIcon from '../assets/li_info.svg';
import successIcon from '../assets/li_success.svg';
import warningIcon from '../assets/li_warning.svg';

const VARIANT_ICON_MAP: Record<string, string> = {
  info: infoIcon as string,
  success: successIcon as string,
  warn: warningIcon as string,
  urgent: errorIcon as string,
  pending: infoIcon as string,
};

type Props = { title?: string; body: string; variant?: string };

const hasTextContent = (html: string) => Boolean(html?.replace(/<[^>]*>/g, '').trim());

const Banner: FC<Props> = ({ title, body, variant = 'info' }) => {
  const showBody = hasTextContent(body);

  return (
    <div className={`banner-container ${variant}`}>
      {title && (
        <div className={`flex flex-row${showBody ? ' banner-title-row' : ''}`}>
          {VARIANT_ICON_MAP[variant] && <img src={VARIANT_ICON_MAP[variant]} alt="icon" className={'h-[18px] mr-2'} />}
          <div className={'banner-title'}>{title}</div>
        </div>
      )}
      {showBody && <div dangerouslySetInnerHTML={{ __html: body }}></div>}
    </div>
  );
};

export default Banner;
